import { __assign } from "tslib";
import React from 'react';
import { RcClasses } from '../../../foundation';
import { RcMenuItem } from '../../Menu/MenuItem';
export var RcDownshiftInputClasses = RcClasses(['root', 'input', 'container'], 'RcDownshiftInput');
export var isItemCanSelected = function (item) {
    return !!(item && !item.disabled && !item.isMember && !item.unSelectable);
};
export var DEFAULT_KEY_TO_CHIPS = [';', ',', '\\n'];
export var DEFAULT_LIMIT_CHIPS = 20;
export var DEFAULT_GET_OPTION_LABEL = function (item) {
    return (item === null || item === void 0 ? void 0 : item.label) || '';
};
export var RcDownshiftDefaultRenderNoOptions = function (getNoOptionsProps) {
    return (React.createElement(RcMenuItem, __assign({ component: "div" }, getNoOptionsProps()), "No Options"));
};
/**
 * default downshift filter options method, use with `variant="tags"`
 *
 * - filter options by input value and selected items
 */
export var RcDownshiftDefaultFilterOptions = function (options, _a) {
    var inputValue = _a.inputValue, getOptionLabel = _a.getOptionLabel, selectedItems = _a.selectedItems;
    return options.filter(function (item) {
        return selectedItems.indexOf(item) < 0 && (getOptionLabel === null || getOptionLabel === void 0 ? void 0 : getOptionLabel(item).toLowerCase().startsWith((inputValue === null || inputValue === void 0 ? void 0 : inputValue.toLowerCase()) || ''));
    });
};
/**
 * default downshift filter options method, use with `variant="autocomplete"`
 *
 * - when open menu and not change value, that will return whole options
 * - only filter options by input value when have input value changed
 */
export var RcAutocompleteDefaultFilterOptions = function (options, _a) {
    var inputValue = _a.inputValue, getOptionLabel = _a.getOptionLabel, inputChanged = _a.inputChanged;
    if (!inputChanged) {
        return options;
    }
    return options.filter(function (item) { return getOptionLabel === null || getOptionLabel === void 0 ? void 0 : getOptionLabel(item).toLowerCase().startsWith((inputValue === null || inputValue === void 0 ? void 0 : inputValue.toLowerCase()) || ''); });
};
export var downshiftComponentName = 'RcDownshift';
export function stringArrToRegExp(keyToTags) {
    // eslint-disable-next-line security/detect-non-literal-regexp
    return new RegExp((keyToTags === null || keyToTags === void 0 ? void 0 : keyToTags.join('|')) || '', 'g');
}
